import { axiosInstance } from "./axios";

export const GetKurumTotalUsedSeansCount = async() => {
  return await axiosInstance
    .get("/corporations/usedSessions")
    .then(res =>  res.data.data)
    .catch((err) => console.log("e", err));
};
